(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name commons.service:StorageServices
     *
     * @description
     *
     */
    angular
        .module('commons')
        .service('StorageServices', StorageServices);

    function StorageServices(localStorageService) {
        var self = this;

        self.KEYS = {
            LAST_TOKEN_ID: 'acl_last_token_id',
            IS_LOGGED_IN : 'alc_is_logged_in',
            LOGIN_INFO : 'login_info',
            LAST_SERVER_CALL_TIMESTAMP : 'last_server_call_timestamp',
            LAST_TOKEN_RECEIVED_TIMESTAMP : 'last_token_received_timestamp',
            CARRIER : 'carrier',
            CARRIER_LIST : 'carrier_list'
        };

        self.set = function (key, value) {
            localStorageService.set(key, value);
        };

        self.get = function (key) {
            return localStorageService.get(key);
        };

        self.setNativeStorage = function(key,value){
            if(typeof(Storage) !== "undefined") {
                if(!!value){
                    localStorage.setItem(key,value);
                }else{
                    localStorage.removeItem(key);
                }
            }
        };

        self.getNativeStorage = function(key){
            if(typeof(Storage) !== "undefined") {
                return localStorage.getItem(key);
            }else{
                return null;
            }
        };

        self.setTabData = function(tabName,key,value){
            var tabLocal = localStorageService.get('tab_local_'+tabName);
            if(!!tabLocal){
                tabLocal[key] = value;
            }else{
                tabLocal = {};
                tabLocal[key] = value;
            }
            localStorageService.set('tab_local_'+tabName,tabLocal);
        };

        self.getTabData  = function(tabName){
            return localStorageService.get('tab_local_'+tabName);
        };

        self.clearTabData = function(tabName){
            localStorageService.set('tab_local_'+tabName,null);
        };

        self.clearAllTabData = function(){
            localStorageService.clearAll(/tab_local_/);
        }

    }
}());
